// OffCanvasMenuTrigger.tsx
import React, { useContext, type MouseEvent, type ReactNode } from 'react';
import { OffCanvasMenuContext } from './OffCanvasMenu';

export interface OffCanvasMenuTriggerProps {
    children: ReactNode;
}

/**
 * The trigger component that toggles the off‑canvas menu.
 * It expects a single React element as its child.
 */
export const OffCanvasMenuTrigger: React.FC<OffCanvasMenuTriggerProps> = props => {
    const { children } = props;
    const context = useContext(OffCanvasMenuContext);

    if (!context) throw new Error('OffCanvasMenuTrigger must be used within an OffCanvasMenu component.');

    const { open, setOpen } = context;

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setOpen(!open);
    };

    // Clone the child element to inject an onClick handler.
    return React.cloneElement(React.Children.only(children) as React.ReactElement<any>, {
        onClick: handleClick,
    });
};
